/* src/app/admin/page-list/page-list.component.scss */
/*# sourceMappingURL=page-list.component-LA4VUCUY.css.map */
